/* eslint-disable max-len */
import React, { useState, useEffect } from "react";
import { object, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import HeaderWrapper from "../../header/header-wrapper";
import NotificationStories from "../../rows/NotificationStories";
import { pushEngage } from "../../helper/api";
import { staticTexts } from "../../utils/Translate";

import "./notification.m.css";

function NotificationPageBase({ data, pushEngageApiKey, publisherAttributes }) {
  const { stories } = data;
  const [notifications, setNotifications] = useState([]);

  if (!stories.length) {
    return (
      <div styleName={`not-found-wrapper ${publisherAttributes.lang === "en" ? "en-wrapper" : ""}`}>
        <Headline text="no stories found !!" headlineType={1} headerLevel={2} />
      </div>
    );
  }

  useEffect(() => {
    const limit = 8;
    const offset = 0;

    pushEngage(offset, limit, pushEngageApiKey).then(resp => setNotifications(resp));
  }, []);

  return (
    <React.Fragment>
      <HeaderWrapper />
      <div>
        <div styleName="content">
          <Headline
            text={staticTexts(publisherAttributes.lang).notifications}
            headerLevel={1}
            headlineType={38}
            className="title"
          />
        </div>

        <div>
          <NotificationStories stories={notifications} />
        </div>
      </div>
    </React.Fragment>
  );
}

NotificationPageBase.propTypes = {
  data: object,
  pushEngageApiKey: string,
  publisherAttributes: object
};

const mapStateToProps = state => ({
  pushEngageApiKey: get(state, ["qt", "config", "publisher-attributes", "push_engage_api_key"], null),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
});

export const NotificationPage = connect(mapStateToProps, null)(NotificationPageBase);
